import { api } from "../api";

/**
 * loginByEmailAndPassword - Function that tries to login an user by login and password   
 * /authenticator/login?useGtf=${useGtf}&isApp=${isApp}
 * method POST 
 * @async-function
 */
const loginByEmailAndPassword = async (email: string |  null, driver: string | null, password: string, useGtf: boolean = false, isApp: boolean = false) => { 
  const response = await api.post(
    `/authenticator/login?useGtf=${useGtf}&isApp=${isApp}`, { email: email, driver: driver, password: password });
  return response;
};

export default loginByEmailAndPassword;
